import { PlatformName } from '@todesktop/shared';
import { currentUser } from '../../../utilities/firestore';
import getCallableFirebaseFunction from '../../../utilities/getCallableFirebaseFunction';
import getProjectConfig from '../../../utilities/projectConfig/getProjectConfig';

export interface ContinueBreakpointOptions {
  buildId: string;
  platform: PlatformName;
  configPath?: string;
  ignoreExtendsErrors?: boolean;
}

export async function continueBreakpoint({
  buildId,
  platform,
  configPath,
  ignoreExtendsErrors,
}: ContinueBreakpointOptions) {
  const projectConfigFlags =
    ignoreExtendsErrors === true
      ? { build: { ignoreExtendsErrors: true } }
      : undefined;

  const { config } = getProjectConfig(configPath, projectConfigFlags);
  const appId = config.id;

  if (!buildId) {
    throw new Error('A build ID is required when using --continue');
  }

  const user = currentUser();
  if (!user) {
    throw new Error('Not authenticated. Please run: todesktop login');
  }

  const idToken = await user.getIdToken(true);

  const resumeBuildBreakpoint = getCallableFirebaseFunction(
    'resumeBuildBreakpoint',
  );

  await resumeBuildBreakpoint({
    appId,
    buildId,
    platform,
    idToken,
  });

  console.info(
    `Sent resume command for build ${buildId} (${platform}). Check the original terminal for progress.`,
  );
}

export function isValidPlatform(
  value: string | undefined,
): value is PlatformName {
  return (
    typeof value === 'string' &&
    Object.values(PlatformName).includes(value as PlatformName)
  );
}
